export default __webpack_public_path__ + "static/ky-40d8ac9e130d665c12aa7dd9c94a0e5a.svg";